import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVesselFullTubeHeatingCoolingCoil = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 120,
	height: 70,
	viewBox: "0 0 120.0 70.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 10,
			y: 0,
			width: 100,
			height: 70,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 5,
			cy: 25,
			rx: 5,
			ry: 5,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 5,
			cy: 55,
			rx: 5,
			ry: 5,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 115,
			cy: 15,
			rx: 5,
			ry: 5,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 115,
			cy: 45,
			rx: 5,
			ry: 5,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgVesselFullTubeHeatingCoolingCoil;
